import React, { useEffect } from 'react';

import { selectMediaConfig } from 'store/media/selector';

import { ArrowLeft } from '@travel/icons/ui';
import { Translate } from '@travel/translation';
import useWindowInfiniteScroll from '@travel/traveler-core/hooks/useWindowInfiniteScroll';
import { IconText } from '@travel/ui';
import LoadingCircle from '@travel/ui/components/FlatButton/loadingCircle';
import cx from '@travel/ui/utils/classnames';

import MediaList from 'components/MediaList';

import { useAppSelector } from 'store/hooks';

import styles from './mediaGallery.module.scss';

import type { Review } from 'store/apiTypes';
type Props = {
  mediaReviews: Review[];
  hasMore?: boolean;
  onClickMedia?: () => void;
  onClose?: () => void;
  isAppendFetching?: boolean;
  onScrollToBottom?: () => void;
};

const MediaGallery = (props: Props) => {
  const { mediaReviews, hasMore, onClickMedia, onClose, isAppendFetching, onScrollToBottom } =
    props;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  useWindowInfiniteScroll({
    isEnabled: !isAppendFetching,
    hasMore: hasMore,
    onScrollToBottom: onScrollToBottom,
    bottomOffset: 100,
  });

  const isEnableVideoUpload = useAppSelector(selectMediaConfig);

  return (
    <div className={cx(styles.mediaGalleryContainer, !hasMore && styles.fullMediaGalleryContainer)}>
      <button
        onClick={onClose}
        className={styles.returnButton}
        data-testid="mediaGallery-returnToProviderReviewPage-button"
      >
        <IconText
          icon={<ArrowLeft size={20} />}
          text={
            <Translate
              id={isEnableVideoUpload ? 'Review.ReviewMedia' : 'Review.ReviewMediaNoVideo'}
              className={styles.returnButtonText}
            />
          }
          spaceBetween={8}
          className={styles.returnButtonIconText}
        />
      </button>
      <MediaList
        reviewMedia={mediaReviews}
        layout={'gallery'}
        mediaCardClassName={styles.clickable}
        onClickMedia={onClickMedia}
        shouldShowLikeCountOverlay
      />
      {hasMore && (
        <div className={styles.loadingSpinner} data-testid="mediaGallery-loadingSpinner-container">
          <LoadingCircle isLoading={true} classType="primary" />
        </div>
      )}
    </div>
  );
};

export default MediaGallery;
